module.exports = __webpack_public_path__ + "img/renzheng.e059d941.png";